import { useState } from "react";
import {
  Box,
  Button,
  Popover,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { IFilterSchema } from "../../../../utils/types";
import {
  handleApplyFilterItemFunction,
  handleResetFilterItemFunction,
} from "./FiltersContainer";
import CloseIcon from "@mui/icons-material/Close";
import { dateFormatter } from "../../../../utils/date-formatter";
import DateTimeFilter from "./DateTimeFilter";

interface FiltersItemProps {
  filter: IFilterSchema;
  onReset: handleResetFilterItemFunction;
  onApply: handleApplyFilterItemFunction;
}

const FiltersItem: React.FC<FiltersItemProps> = ({
  filter,
  onReset,
  onApply,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApply = (column: string, operator: string, value: any) => {
    onApply(column, operator, value);
    handleClose();
  };

  const handleReset = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (filter.props.value) {
      onReset(filter.props.columnName);
    } else {
      handleClick(e);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        disableRipple
        onClick={handleClick}
        sx={{
          textTransform: "none",
          borderRadius: "9999px",
          height: 28.5,
          px: 1,
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        <IconButton size="small" onClick={handleReset}>
          <AddIcon
            fontSize="small"
            sx={{ transform: filter.props.value ? "rotate(45deg)" : "none" }}
          />
        </IconButton>
        <Typography
          variant="button"
          component="span"
          fontWeight={"medium"}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          بر اساس {filter.props.label}
          {filter.props.value && (
            <>
              {" "}
              |{" "}
              <Typography
                variant="button"
                component="span"
                color="primary"
                dir="rtl"
                sx={{ textTransform: "none" }}
              >
                {filter.FilterComponent === DateTimeFilter
                  ? dateFormatter({
                      lang: "fa",
                      date: filter.props.value,
                    }).slice(9)
                  : Array.isArray(filter.props.value) &&
                    filter.props.value.length > 0
                  ? filter.props.value
                      .map((val) =>
                        filter.options ? filter.options[val] : val
                      )
                      .join(", ")
                  : filter.options
                  ? filter.options[filter.props.value]
                  : filter.props.value}
              </Typography>
            </>
          )}
        </Typography>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            mr: 1,
            overflow: "visible",
            direction: "rtl",
          },
        }}
      >
        <Box sx={{ p: 2, minWidth: 280 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
              direction: "rtl",
            }}
          >
            <Typography variant="body1">{`فیلتر بر اساس ${filter.props.label}`}</Typography>
            <IconButton size="small" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <filter.FilterComponent
            handleApplyFilter={handleApply}
            value={filter.props.value}
            operator={filter.props.operator}
            columnName={filter.props.columnName}
            options={filter.options}
          />
        </Box>
      </Popover>
    </>
  );
};

export default FiltersItem;
